import { render, staticRenderFns } from "./rsStandardOrderDetail.vue?vue&type=template&id=195e2ab0&scoped=true"
import script from "./rsStandardOrderDetail.vue?vue&type=script&lang=js"
export * from "./rsStandardOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./rsStandardOrderDetail.vue?vue&type=style&index=0&id=195e2ab0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e2ab0",
  null
  
)

export default component.exports